<template>
  <div
    class="photo-advice container flex flex-row items-center justify-center mx-auto px-1 sm:px-16 lg:px-32 xl:px-64 py-2"
    id="photoadvice"
    style="display: none"
  >
    <div class="relative">
      <img
        :alt="imageAlt"
        :src="imageSrc"
        id="advice-img"
        crossorigin="anonymous"
        class="object-cover object-top"
        style="box-shadow: 0 0 0 100px inset, 0 0 5px grey"
        :onload="imageLoaded"
      />

      <h2
        id="advice-text"
        class="p-3 text-xl sm:text-2xl md:text-3xl font-bold absolute px-8 md:px-16 text-white bg-black w-full text-center shadow-2xl opacity-75"
        style="
          top: 80%;
          left: 50%;
          transform: translate(-50%, -50%);
        "
      >{{ advice }}</h2>
      <!-- display: none; -->

      <div
        id="advice-text-edit-block"
        class="absolute w-full"
        style="
          top: 80%;
          left: 50%;
          transform: translate(-50%, -50%);
          display: none;
        "
      >
        <div class="flex flex-row items-end justify-end pr-5 pb-3 md:pb-5">
          <button style="outline: none" @click="addVal" class="pr-4" aria-label="Update quote text">
            <svg viewBox="-50 142 510 510" class="w-6 md:w-10">
              <g>
                <polygon
                  class="icon-bg"
                  points="154,453.1 62.2,361.3 26.5,397 154,524.5 383.5,295 347.8,259.3  "
                />
                <path
                  class="icon-color"
                  d="M205,142C64.8,142-50,256.8-50,397S64.8,652,205,652s255-114.8,255-255S345.3,142,205,142z M154,524.5L26.5,397l35.7-35.7
                                    l91.8,91.8l193.8-193.8l35.7,35.7L154,524.5z"
                />
              </g>
            </svg>
          </button>
          <button style="outline: none" @click="cancelVal" class="pr-4" aria-label="Cancel Edit">
            <svg viewBox="-49 141 512 512" class="w-6 md:w-10">
              <path
                class="icon-color"
                d="M207,141C65.8,141-49,255.8-49,397S65.8,653,207,653s256-114.8,256-256S348.2,141,207,141z"
              />
              <path
                class="icon-bg"
                d="M301.3,461.1c8.3,8.3,8.3,21.8,0,30.2c-4.2,4.2-9.6,6.3-15.1,6.3c-5.5,0-10.9-2.1-15.1-6.3L207,427.2
                                l-64.1,64.1c-4.2,4.2-9.6,6.3-15.1,6.3c-5.5,0-10.9-2.1-15.1-6.3c-8.3-8.3-8.3-21.8,0-30.2l64.1-64.1l-64.1-64.1
                                c-8.3-8.3-8.3-21.8,0-30.2c8.3-8.3,21.8-8.3,30.2,0l64.1,64.1l64.1-64.1c8.3-8.3,21.8-8.3,30.2,0c8.3,8.3,8.3,21.8,0,30.2L237.2,397
                                L301.3,461.1z"
              />
            </svg>
          </button>
          <button
            aria-label="Reset quote text to original"
            style="outline: none"
            @click="originalVal"
            class="font-semibold bg-gradient-to-r from-orange-600 via-orange-500 to-orange-600 rounded-full text-white py-1 md:py-2 text-xs md:text-sm px-4"
          >Original</button>
        </div>

        <textarea
          id="advice-text-edit"
          class="p-3 text-xl sm:text-2xl md:text-3xl font-bold px-8 md:px-16 text-white bg-black w-full text-center shadow-2xl opacity-75"
          style="border: none; outline: none; resize: none; overflow: hidden"
        >
          {{ advice }}
        </textarea>
      </div>
      <!-- edit block end -->
    </div>
  </div>

  <div
    class="action-buttons container flex flex-row items-end justify-end mx-auto px-0 py-2 sm:px-16 lg:px-32 xl:px-64 pb-3 border-b border-gray-500"
  >
    <button class="refresh pr-5" style="outline: none" aria-label="Reload page">
      <a href="/" aria-label="Home Page">
        <svg viewBox="0 0 361 359.3" class="w-8 md:w-12">
          <path
            class="icon-color"
            d="M350.7,183.5c0.1,92.1-74.7,167.1-166.9,167.1c-92.3,0-167.3-74.7-167.4-166.7C16.3,91.5,91.1,16.4,183.1,16.3
						C275.8,16.2,350.6,90.8,350.7,183.5z M274.1,142.4c-1.7-3.1-2.7-5-3.8-6.9c-26.9-48.4-88.6-65.6-136.2-37.9
						c-40.6,23.7-59.5,73-44.6,116.5c15.8,46.2,59.9,74,107.7,67.4c21-2.9,39.4-11.7,54.8-26.5c7.2-7,7.7-14.8,1.6-21
						c-5.7-5.8-13.6-5.6-20.6,0.7c-0.9,0.8-1.8,1.7-2.7,2.5c-14.5,12.4-31.3,18.5-50.2,17.2c-29.4-2-51-16.7-62.1-44
						c-10.8-26.3-6.8-51.7,11.9-73.3c19.6-22.6,45-29.5,73.6-21.8c21.4,5.8,36.5,19.8,44.8,40.7c-5.9-2.1-11.2-5-16.7-7.7
						c-8.2-3.9-16.3-1.6-19.9,5.5c-3.6,7.1-1.2,14.6,6.7,18.9c14.4,7.8,29,15.4,43.6,22.8c7.1,3.6,14.6,2,18.3-4.7
						c8.5-15.5,16.6-31.1,24.3-47c3.2-6.6,0-14-6.1-17.2c-6.6-3.5-14-1.5-18.2,5C278.3,134.8,276.6,138.1,274.1,142.4z"
          />
        </svg>
      </a>
    </button>
    <button class="edit-pencil pr-5" style="outline: none" @click="editVal" aria-label="Edit quote text">
      <svg viewBox="0 0 491.5 486.4" class="w-8 md:w-12">
        <path
          id="XMLID_43_"
          class="icon-color"
          d="M245.4,17.1c127.4,0,230.9,103.5,230.8,230.9c-0.1,127.7-103.6,230.9-231.4,230.8
					C117.5,478.7,14.3,375,14.4,247.4C14.6,120.3,118.1,17.1,245.4,17.1z M181.9,348.8c55.1-55.1,110.2-110.2,165-165
					c-12.6-12.6-24.9-25-37.3-37.3c-54.9,54.9-110.1,110-165.1,164.8C157.1,324,169.3,336.2,181.9,348.8z M353.4,176.7
					c6-5.8,12.3-11.3,17.7-17.5c8.8-10,8.2-24.9-0.6-34.6c-9.1-10-24.2-12.2-34.7-3.6c-7,5.7-12.4,13.3-18.3,19.8
					C328.8,152.2,341,164.4,353.4,176.7z M174.4,355.5c-12.4-12.4-24.5-24.4-36.8-36.6c-6.3,18.1-12.7,36.6-19.4,56.1
					C137.9,368.2,156.3,361.8,174.4,355.5z"
        />
      </svg>
    </button>
    <button class="download pr-5" style="outline: none" aria-label="Download quote graphic">
      <a
        aria-label="Download Quote"
        id="downloader"
        :download="`${advice}.png`"
      >
        <svg viewBox="0 0 515.3 508.5" class="w-8 md:w-12">
          <path
            id="XMLID_7_"
            class="icon-color"
            d="M256.5,8.7C121,8.7,11.2,118.6,11.2,254.1S121,499.4,256.5,499.4s245.3-109.8,245.3-245.3
                        C501.7,118.6,391.9,8.9,256.5,8.7z M413.4,282.9L264,432.5c-4.2,4.2-10.9,4.2-15.1,0L99.6,282.9c-2-2-3.1-4.7-3.1-7.6
                        c0-5.9,4.8-10.7,10.7-10.6h74.7V104.9c0-5.9,4.8-10.7,10.7-10.7h128c5.9,0,10.7,4.8,10.7,10.7v159.8h74.7c4.3,0,8.2,2.6,9.9,6.6
                        C417.3,275.3,416.4,279.9,413.4,282.9z"
          />
        </svg>
      </a>
    </button>
  </div>
  <!-- action buttons end -->

  <div
    class="photo-credits container flex flex-col md:flex-row items-start justify-between mx-auto px-0 py-2 sm:px-16 lg:px-32 xl:px-64 px-5 mb-8 pb-3 border-b border-gray-500"
  >
    <p class="text-md md:text-xl uppercase text-gray-900 font-semibold">
      Photo Credits :
      <span class="capitalize text-gray-800">{{ photographer }}</span>
    </p>
    <p class="text-md md:text-xl uppercase text-gray-900 font-semibold">
      Image Provider :
      <span class="capitalize text-gray-800">
        <a aria-label="Pexels.com Website" href="https://www.pexels.com">Pexels.com</a>
      </span>
    </p>
  </div>
  <!-- photo credits end -->

  <canvas id="canvas" style="display: none"></canvas>
  <!-- Canvas for drawing div's as image -->
  <div>
    <h2
      id="canvas-advice"
      style="display: none; text-align: center"
      class="p-4 px-16 text-white bg-black shadow-2xl opacity-75 font-bold"
    >{{ advice }}</h2>
    <!-- this is the advice html element which is drawn -->
  </div>
</template>

<script>
import html2canvas from "html2canvas";

export default {
  name: "Advice",
  props: {
    photographer: {
      type: String,
    },
    advice: {
      type: String,
    },
    imageSrc: {
      type: String,
    },
    imageAlt: {
      type: String,
    },
  },
  methods: {
    getDownloadUrl() {
      const img = document.querySelector("#advice-img");
      document.querySelector("#canvas-advice").style.width =
        img.naturalWidth + "px";
      let smallSide;
      if (img.naturalWidth < img.naturalHeight) {
        smallSide = img.naturalWidth;
      } else if (img.naturalHeight < img.naturalWidth) {
        smallSide = img.naturalHeight;
      } else {
        smallSide = img.naturalHeight;
      }
      // calculate font size based on small side of the image
      document.querySelector("#canvas-advice").style.fontSize =
        0.05 * smallSide + "px";
      const canvas = document.getElementById("canvas");
      let ctx = canvas.getContext("2d");
      // set canvas size to image size
      canvas.width = img.naturalWidth;
      canvas.height = img.naturalHeight;
      // draw the image to canvas
      ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
      var domElement = document.getElementById("canvas-advice");
      html2canvas(domElement, {
        onclone: function (doc) {
          var adviceElementCanvas = doc.getElementById("canvas-advice");
          adviceElementCanvas.style.display = "block";
          // adviceElementCanvas.style.fontFamily = `ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"`
        },
        onrendered: function (adviceText) {
          var canvas = document.getElementById("canvas");
          canvas
            .getContext("2d")
            .drawImage(
              adviceText,
              0,
              (75 / 100) * canvas.height -
                Math.ceil(adviceText.getBoundingClientRect().height)
            );
          document
            .querySelector("#downloader")
            .setAttribute("href", canvas.toDataURL("image/png"));
        },
      });
    },
    imageLoaded() {
      document.getElementById('photoadvice').style.display = "flex";
      this.getDownloadUrl();
    },
    editVal() {
      var originalVal = document.querySelector("#advice-text");
      originalVal.style.display = "none";
      var customVal = document.querySelector("#advice-text-edit");
      customVal.value = originalVal.innerHTML;

      document.querySelector("#advice-text-edit-block").style.display = "block";
    },
    originalVal() {
      var originalVal = document.querySelector("#advice-text");
      originalVal.style.display = "block";
      // var customVal = document.querySelector("#advice-text-edit");
      originalVal.innerHTML = this.advice;
      document.querySelector("#canvas-advice").innerHTML =
        originalVal.innerHTML;

      // refresh the download
      this.getDownloadUrl(); // TO UNCOMMENT

      document.querySelector("#advice-text-edit-block").style.display = "none";
    },
    addVal() {
      var originalVal = document.querySelector("#advice-text");
      originalVal.style.display = "block";
      var customVal = document.querySelector("#advice-text-edit");
      if (customVal.value == "") {
        return;
      }
      originalVal.innerHTML = customVal.value;
      document.querySelector("#canvas-advice").innerHTML = customVal.value;

      // refresh the download
      this.getDownloadUrl(); // TO UNCOMMENT

      document.querySelector("#advice-text-edit-block").style.display = "none";
    },
    cancelVal() {
      var originalVal = document.querySelector("#advice-text");
      originalVal.style.display = "block";
      var customVal = document.querySelector("#advice-text-edit");
      customVal.value = originalVal.innerHTML;

      document.querySelector("#advice-text-edit-block").style.display = "none";
    },
  },
};
</script>

<style scoped>
.icon-bg {
  fill: #ffffff;
}
.icon-color {
  fill: #ec8834;
}
</style>
